import { render, staticRenderFns } from "./ReactionDetail.vue?vue&type=template&id=39d220b5&scoped=true"
import script from "./ReactionDetail.vue?vue&type=script&lang=js"
export * from "./ReactionDetail.vue?vue&type=script&lang=js"
import style0 from "./ReactionDetail.vue?vue&type=style&index=0&id=39d220b5&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d220b5",
  null
  
)

export default component.exports